import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'topFiveProblems',
    label: 'Top Five Problems',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
